import moment from 'moment';

const winston = require('winston');
// Niveles de log
// en orden de importancia
// descendente
const LOGGER_LEVELS = {
  emerg: 'emerg',
  alert: 'alert',
  crit: 'crit',
  error: 'error',
  warning: 'warning',
  notice: 'notice',
  info: 'info',
  debug: 'debug',
};

// Nivel mínimo a loggear
// (niveles más bajos se ignoran)
const MIN_LEVEL = process.env.REACT_APP_WINSTON_MIN_LVL || 'debug';

// eslint-disable-next-line new-cap
export const logger = new winston.createLogger({
  levels: winston.config.syslog.levels,
  format: winston.format.json(),
  transports: [
    new winston.transports.Console({
      level: MIN_LEVEL,
      timestamp: true,
    }),
  ],
});

export const getFormattedDate = (date, format = 'YYYY-MM-DD') => {
  return date ? moment.utc(date, format).format(format) : moment.utc().format(format) ;
};

export const getFormattedDateForPicker = (date, format = 'MM-DD-YYYY') => {
  return date ? moment.utc(date).format(format) : moment.utc().format(format) ;
};

export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const addCommas = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

export const thousandSeparator = (value) => {
  return addCommas(removeNonNumeric(value));
};

export const checkAuthorization = (rolesPermitidos) => {
  const token = localStorage.getItem("token");
  if (!token) {
    alert("Acceso no autorizado");
    return (window.location.href = "/logout");
  }
  const decodedToken = parseJwt(token);
  const isPermitido = rolesPermitidos.filter(
    (item) => item === decodedToken.rol
  );
  if (isPermitido.length === 0) {
    alert("Acceso no autorizado");
    return (window.location.href = "/logout");
  }
};

export const cajaOptions = () => [
  { value: "Automatico", label: "Automatico" },
  { value: "Manual", label: "Manual" },
];

export const colorOptions = () => [
  { value: "Azul", label: "Azul" },
  { value: "Rojo", label: "Rojo" },
  { value: "Negro", label: "Negro" },
  { value: "Blanco", label: "Blanco" },
];

export const combustibleOptions = () => [
  { value: "Diesel", label: "Diesel" },
  { value: "Gasolina", label: "Gasolina" },
  { value: "Etanol", label: "Etanol" },
  { value: "Hidrogeno", label: "Hidrogeno" },
  { value: "Electricidad", label: "Electricidad" },
  { value: "Metanol", label: "Metanol" },
  { value: "PSeries", label: "PSeries" },
  { value: "Gas", label: "Gas" },
  { value: "GLP", label: "GLP" },
];
export const cuerpoOptions = () => [
  { value: "Sedan", label: "Sedan" },
  { value: "SUV", label: "SUV" },
  { value: "Notchback", label: "Notchback" },
  { value: "Fastback", label: "Fastback" },
  { value: "Hatchback", label: "Hatchback" },
  { value: "Hard Top", label: "Hard Top" },
  { value: "Targa", label: "Targa" },
  { value: "Shooting Brake", label: "Shooting Brake" },
  { value: "Station Wagon", label: "Station Wagon" },
  { value: "Coupe", label: "Coupe" },
  { value: "Roadster", label: "Roadster" },
  { value: "Monovolumen", label: "Monovolumen" },
  { value: "Familiar", label: "Familiar" },
  { value: "Pick Up", label: "Pick Up" },
];
export const duenhosOptions = () => [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "Más de 3" },
];
export const estadoSubmodeloOptions = () => [
  { value: "VALIDANDO", label: "VALIDANDO" },
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

export const diasOptions = () => [
  { value: 1, label: "Lunes" },
  { value: 2, label: "Martes" },
  { value: 3, label: "Miercoles" },
  { value: 4, label: "Jueves" },
  { value: 5, label: "Viernes" },
  { value: 6, label: "Sabado" },
  { value: 7, label: "Domingo" },
];
export const modelosOptions = (modelos) =>
  modelos
    ? modelos.map((item) => ({
        value: item.name,
        label: item.name,
      }))
    : [];

export const marcaOptions = (marcas) =>
  marcas
    ? marcas.map((item) => ({
        value: item.make,
        label: item.make,
      }))
    : [];

export const TINYMCE_SCRIPT_SRC = `${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`;
export const TINYMCE_CONFIG = {
  height: 500,
  menubar: false,
  plugins: [
    "advlist autolink lists link image charmap print preview anchor",
    "searchreplace visualblocks code fullscreen",
    "insertdatetime media table paste code help wordcount",
  ],
  toolbar:
    "undo redo | formatselect | " +
    "bold italic backcolor | alignleft aligncenter " +
    "alignright alignjustify | bullist numlist outdent indent | " +
    "removeformat | help",
  content_style:
    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
};


